import { Message } from 'semantic-ui-react'
import { LoaderBar } from 'components'
import { GetApprovalWorkflowConfig } from 'hooks'
import { ApprovalWorkflowConfig } from 'page-components/report-approval'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

// The approval-workflow API takes the NUMERIC template id. Older links put the template GUID in the URL (the
// API answered 404, shown as "CORS / network", and the page offered an empty form) - fall back to the numeric
// id passed in the navigation state (2026-10-22).
const numericTemplateId = (param, state) => {
    if (/^\d+$/.test(String(param || ''))) return String(param)
    const fromState = state?.templateNumericId
    return /^\d+$/.test(String(fromState || '')) ? String(fromState) : null
}

export const TemplateApprovalWorkflowScreen = () => {
    const { templateId } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const templateName = location.state?.templateName || ''
    const resolvedId = numericTemplateId(templateId, location.state)
    const { data, raw, loading, error } = GetApprovalWorkflowConfig(
        resolvedId || '',
    )
    const onBack = () => navigate('/app/templates')

    // never show an editable (empty) form when the real workflow could not be read
    if (!resolvedId || error) {
        return (
            <Message warning>
                <Message.Header>Approval workflow</Message.Header>
                <p>
                    {error ||
                        'Open the approval workflow from the Templates list (template menu > Approval Workflow).'}
                </p>
                <button type="button" className="ui button" onClick={onBack}>
                    Back to templates
                </button>
            </Message>
        )
    }

    // nothing editable until this template's workflow has been read (review 2026-10-22)
    if (loading || !data) return <LoaderBar content="Loading workflow…" />

    return (
        <ApprovalWorkflowConfig
            key={resolvedId}
            templateId={resolvedId}
            templateName={templateName}
            config={data}
            rawConfig={raw}
            loading={loading}
            onBack={onBack}
        />
    )
}
